import { ImResponse, doorClient, resolve, storeHomeClient } from 'services/api';

export interface ConfigParams {
  groupId: string | number;
  needPolicy: boolean;
}

export interface ConfigResponse extends NightWatch.StoreGroupConfig {
  policy: NightWatch.Policy[];
}

export function config(params: ConfigParams) {
  return resolve(
    doorClient.get<ImResponse<ConfigResponse>>('/policy/v1/night-watch/fallback', { params }),
  );
}

export function policy(id: string | number) {
  return resolve(
    doorClient.get<ImResponse<NightWatch.Policy>>('/policy/v1/night-watch/fallback-policy', {
      params: { id },
    }),
  );
}

export function updateConfig(body: NightWatch.StoreGroupConfig) {
  return doorClient.post('/policy/v1/night-watch/fallback', body);
}

export function createPolicy(body: Omit<NightWatch.Policy, 'fallbackPolicyId' | 'priority'>) {
  return doorClient.post('/policy/v1/night-watch/fallback-policy', body);
}

export function updatePolicy(body: NightWatch.Policy) {
  return doorClient.post('/policy/v1/night-watch/fallback-policy', body);
}

export function deletePolicy(id: string | number) {
  return doorClient.delete('/policy/v1/night-watch/fallback-policy', { params: { id } });
}

export interface UpdatePolicyPriorityParams {
  fallbackPolicyId: number;
  priorityActionType: 'UP' | 'DOWN' | 'TOP' | 'BOTTOM';
}

export function updatePolicyPriority(params: UpdatePolicyPriorityParams) {
  return doorClient.post('/policy/v1/night-watch/fallback-policy/priority', null, { params });
}

export function watchConfig(storeGroupId: string | number) {
  return resolve(
    storeHomeClient.get<ImResponse<NightWatch.WatchConfig>>(
      `/store_groups/${storeGroupId}/watch_config`,
    ),
  );
}

export function updateWatchConfig(id: string | number, body: Partial<NightWatch.WatchConfig>) {
  return storeHomeClient.put(`/store_group_configs/${id}/watch_config`, body);
}

export function init(groupId: string | number) {
  return doorClient.post('/policy/v1/night-watch/fallback/init', null, { params: { groupId } });
}
